import React from "react"
import "./expand-toggle.css"
import { ReactComponent as ArrowDown } from "../assets/arrow-down.svg"

const ExpandToggle = ({
    isExpanded,
    setIsExpanded,
    stubs = ['Развернуть', 'Свернуть'],
}) => {
    let content = ''
    if (isExpanded) {
        content = <><ArrowDown className="expand-toggle__arrow" /> {stubs[1]}</>
    } else {
        content = <><ArrowDown className="expand-toggle__arrow expand-toggle__arrow--right" /> {stubs[0]}</>
    }

    return (
        <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="expand-toggle"
            type="button"
        >
            {content} 
        </button>
    )
}

export default ExpandToggle